import { useCallback } from "react";

/**
 * Hook to send component_action messages via the active WebSocket.
 */
export const useComponentAction = () => {
  const sendAction = useCallback((componentType, action, params = {}) => {
    const message = {
      type: "component_action",
      payload: {
        component_type: componentType,
        action,
        params,
      },
    };

    if (window.activeChatSocket?.readyState === WebSocket.OPEN) {
      window.activeChatSocket.send(JSON.stringify(message));
    } else {
      console.warn("WebSocket not open; cannot send component_action.");
    }
  }, []);

  return { sendAction };
};
